import styled from "@emotion/styled";

export const ActivityActionPackageStyled = styled('div')`
    padding: 1rem 2rem;

`;